import request from "@/utils/request";
// import { getToken } from "@/utils/auth"; // get token

const API = process.env.VUE_APP_PORTAL_API;

// 获取用户按钮权限
export function getUserButtonPermission() {
  return request({
    url: `${API}api/rest/resource/queryCurrentUserResourceByType?type=BUTTON`,
    method: "get"
  });
}

// 用户导航 - 获取列表
export function getUserNav() {
  return request({
    url: `${API}v1/user/config/get`,
    method: "get"
  });
}

// 用户导航 - 保存排序
export function saveUserNav(data) {
  return request({
    url: `${API}api/proxy/service/api/common/desktop/setting/saveNavigationBarSetting`,
    method: "post",
    data: data
  });
}

// 用户桌面 - 获取一级桌面
export function getUserDesktop() {
  return request({
    url: `${API}api/proxy/service/api/common/desktop/setting/userDesktopSettingInfo`,
    method: "get"
  });
}

// 用户桌面 - 获取当前桌面的组件
export function getUserComponents(id) {
  return request({
    url: `${API}api/proxy/service/api/common/desktop/setting/userSonDesktopSettingInfo?cardId=${id}`,
    method: "get"
  });
}

// 用户桌面 - 保存桌面组件
export function saveUserComponents(data) {
  return request({
    url: `${API}api/proxy/service/api/common/desktop/setting/saveUserDesktopSetting`,
    method: "post",
    data: data
  });
}

// 获取子组件
export function getSubComponents(params) {
  return request({
    url: `${API}api/proxy/service/api/common/desktop/setting/userSonDesktopSettingInfo`,
    method: "get",
    params: params
  });
}

// 个人信息 - 成绩
export function getUserGrade() {
  return request({
    url: `${API}api/proxy/personalData/api/common/userdata/score/getScore`,
    method: "get"
  });
}

// 个人信息 - 图书借阅
export function getUserBook() {
  return request({
    url: `${API}api/proxy/personalData/api/common/userdata/book/getUnReturnCount`,
    method: "get"
  });
}

// 个人信息 - 邮箱
export function getUserMail() {
  return request({
    url: `${API}api/proxy/personalData/api/common/userdata/email/getEmailNew`,
    method: "get"
  });
}

// 个人信息 - 论文
export function getUserPaper() {
  return request({
    url: `${API}api/proxy/personalData/api/common/userdata/paper/getPaperInfo`,
    method: "get"
  });
}

// 个人信息 - 科研
export function getUserResearch() {
  return request({
    url: `${API}api/proxy/personalData/api/common/userdata/scientific/count`,
    method: "get"
  });
}

